module.exports = __webpack_public_path__ + "img/arrow-right.9e942fcd.svg";